/**
 * File: WaitlistModal.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.4.5
 * Created: 2025-12-31
 * Last Updated: 2026-06-04
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useState } from "react";

// Local project files
import { TextButton } from "../ui/Buttons";
import { waitlistModal } from "../../schemas/components/waitlistModal";
import EmailField from "../forms/EmailField";
import FormHeader from "../forms/FormHeader";
import ModalOverlay from "../ui/ModalOverlay";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function WaitlistModal({ onClose }) {
    const [email, setEmail] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        onClose();

        try {
            await fetch(`${process.env.REACT_APP_WAITLIST_URL}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });
            await fetch(
                `${process.env.REACT_APP_NOTIFICATION_URL}/emails/waitlist`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email }),
                },
            );
        } catch (error) {
            console.error("Error submitting waitlist form:", error);
        }
    };

    return (
        <>
            <ModalOverlay onClick={onClose} />
            <div className="waitlist-modal">
                <form onSubmit={handleSubmit} className="waitlist-modal__form">
                    <FormHeader
                        header={waitlistModal.formHeader.header}
                        subheader={waitlistModal.formHeader.subheader}
                        closeButton={true}
                        onClick={onClose}
                        alignLeft={true}
                    />
                    <fieldset>
                        <EmailField email={email} setEmail={setEmail} />
                    </fieldset>
                    <TextButton
                        text={waitlistModal.textButton.text}
                        type={waitlistModal.textButton.type}
                    />
                </form>
            </div>
        </>
    );
}

export default WaitlistModal;
